import { render } from "./exchangeAddr.vue?vue&type=template&id=1d638c92&scoped=true"
import script from "./exchangeAddr.vue?vue&type=script&lang=js"
export * from "./exchangeAddr.vue?vue&type=script&lang=js"

import "./exchangeAddr.vue?vue&type=style&index=0&id=1d638c92&lang=less&scoped=true"
script.render = render
script.__scopeId = "data-v-1d638c92"

export default script